(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./AvailabilityBadge.module.css";

function AvailabilityBadge(_ref) {
  let {
    className,
    isExist,
    isProhibited
  } = _ref;
  return isExist ? /*#__PURE__*/React.createElement("div", {
    className: cx(styles.availabilityBadge, className, {
      [styles.prohibited]: isProhibited
    })
  }, isProhibited ? "P" : "R") : null;
}

AvailabilityBadge.propTypes = {
  className: PropTypes.string,
  isExist: PropTypes.bool,
  isProhibited: PropTypes.bool
};
AvailabilityBadge.defaultProps = {
  className: null,
  isExist: false,
  isProhibited: false
};

const _default = /*#__PURE__*/React.memo(AvailabilityBadge);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AvailabilityBadge, "AvailabilityBadge", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/AvailabilityBadge/AvailabilityBadge.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/AvailabilityBadge/AvailabilityBadge.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();